import logo from './logo.svg';
import './App.css';
import ClientFormUS from './client_intake_form_us';

function App() {
  return (
    <ClientFormUS />
  );
}

export default App;
